module.exports = __webpack_public_path__ + "img/tissu_pink.fa4bf313.png";